import { useState, useEffect } from "react"
import styled from "styled-components"
import AdminMenu from "./AdminMenu";
import axios from "axios"
import { useAuthStore } from "../store/store"
import moment from "moment"
import { NavLink} from "react-router-dom"
import PageHeader from "../components/PageCloseButton";


const UserList = () => {
  const { auth } = useAuthStore();
  const [users, setusers] = useState([])
  const [sortUser, setSortUser] = useState("asc");
  
  
  const getUsers = async () => {
    try {
      const { data } = await axios.get("/api/user", {
        headers: {
          Authorization: `Bearer ${auth.token}`
        }
      });
      console.log("Orders from backend:", data);
      setusers(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    console.log("useEffect triggered, token:", auth?.token);
    if (auth?.token) getUsers();
  }, [auth?.token]);


const sortedUser = [...users].sort((a, b) => {
const userA = (a.username).toUpperCase();
const userB = (b.username ).toUpperCase();

  return sortUser === "asc"
    ? userA.localeCompare(userB)
    : userB.localeCompare(userA);
});



  return (
     <Wrapper>
    <div className="grid grid-two-column">
      <AdminMenu />
      <div className="user-container">
         <PageHeader title="Users List" /> 
        <div className="table-container">
          <table>
            <thead>
              <tr>
                 <th>Created At</th>
                <th   onClick={() =>
                    setSortUser((prev) => (prev === "asc" ? "desc" : "asc"))
                    }
                  style={{ cursor: "pointer" }}
                  >
                  User {sortUser === "asc" ? "▲" : "▼"}</th>
                <th>Name</th>
                <th>Country</th>     
                <th>Email</th>
                <th>Phone No</th>
                <th>Role</th>
              </tr>
            </thead>
            <tbody>
                  {sortedUser.length > 0 ? (
                    sortedUser.map((user) => (
                  <tr key={user._id}>
                    <td>{moment(user?.createdAt).format("DD/MM/YYYY")}</td>
                    
                    <td><NavLink to={`/userdetails/${user._id}`}>{user.username}</NavLink></td>
                    <td>{user.name || "N/A"}</td>
                     <td>{user.country}</td>
                    <td>{user.email}</td>
                    <td>(+{user.isdCode}) - {user.mobile}</td>
                    <td>{user.role || "User"}</td>
                    
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8">No users found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </Wrapper>
  )
}
const Wrapper = styled.div`

 .grid-two-column{
      display: grid;
      grid-template-columns: 2fr 8fr;
      gap: 2rem;
      }

  .user-container{
      padding: 2rem;   
      }

  .table-container {
    margin-top:2rem;
    margin-bottom:2rem;
    max-height: 400px;
    overflow-y: auto;
    border: 1px solid #ddd;
    box-shadow: 0 4px 12px rgba(0,0,0,0.3);
    }

  table {
      margin:2rem ;
      width: 97%;
      border-collapse: collapse;
      border-radius: 10px;
      overflow: hidden;
      box-shadow: 0 4px 12px rgba(0,0,0,0.08);
      }

thead {
      background-color: ${({ theme }) => theme.colors.font};
      color: #fff;
    }

  thead th {
      position: sticky;
      top: 0;
      padding: 12px;
      font-size: 14px;
      text-align: left;
      letter-spacing: 0.5px;
      z-index: 2;
      }

  tbody tr {
      border-bottom: 1px solid #eee;
      transition: 0.2s ease;
      }

  tbody tr:hover {
    background-color: #f9f9f9;
    }

  td {
    padding: 12px;
    font-size: 14px;
    vertical-align: top;
    }


  td div {
    margin-bottom: 4px;
    }

  
@media (max-width: ${({ theme }) => theme.media.mobile}) {

.grid {
    grid-template-columns: 1fr;
    }

  table{
   display: block; 
   width: 90%;
  }
  
  thead, tbody, th, td, tr {
      display: block; 
      }

  thead {
      display: none;
      }

  tr {
      margin-bottom: 1rem;
      border: 1px solid #ddd;
      padding: 0.2rem;
      border-radius: 6px;
      }

  td {
      border: none;
      position: relative;
      padding: 0.5rem 0.5rem 0.5rem 1rem;
      }

  td::before {
      position: absolute;
      left: 0.2rem;
      font-weight: bold;
      content: attr(data-label); 
      }
    }
  
`;

export default UserList